import './saveAndCancel.scss';

export const SaveAndCancel = angular
    .module('checkout.components.saveAndCancel', [])
    .component('saveAndCancel', {
        template: `
            <div layout class="save-and-cancel">
                <button 
                    class="checkout-button checkout-button--border"
                    type="button"
                    test-id="cancel-button"
                    ng-click="$ctrl.onCancelClicked()">
                    Cancel
                </button>
                <button
                    class="checkout-button checkout-button--primary"
                    type="button"
                    ng-click="$ctrl.onSaveClicked()"
                    test-id="save-button">
                    <span ng-if="!$ctrl.showSaveLoader">Save</span>
                    <md-progress-circular
                        ng-if="$ctrl.showSaveLoader"
                        md-diameter="15"
                        md-mode="indeterminate">
                    </md-progress-circular>
                </button>
            </div>
        `,
        bindings: {
            onSaveClicked: '&',
            onCancelClicked: '&',
            showSaveLoader: '<'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/saveAndCancel/saveAndCancel.js